<template>
    <div class="not-found">
        <div class="error-container">
            <h1>404</h1>
            <p>抱歉，您访问的页面不存在</p>
            <el-button type="primary" @click="goHome">返回首页</el-button>
        </div>
    </div>
</template>

<script lang="ts" setup>
import { onMounted } from 'vue';
import { useRouter } from 'vue-router';
import { ElButton } from 'element-plus';

const router = useRouter();

onMounted(() => {
    console.log('404页面组件挂载完成');
});

const goHome = () => {
    router.push('/home');
};
</script>

<style lang="less" scoped>
.not-found {
    display: flex;
    justify-content: center;
    align-items: center;
    height: 100%;
    background-color: #f5f5f5;

    .error-container {
        text-align: center;
        padding: 2rem;

        h1 {
            font-size: 4rem;
            color: #409eff;
            margin-bottom: 1rem;
        }

        p {
            font-size: 1.2rem;
            color: #666;
            margin-bottom: 2rem;
        }
    }
}
</style>